// store/paymentHistoryCxc.slice.ts

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PaymentHistoryCxcState {
  /**
   * 📌 Historial actual cargado
   */
  history: any | null;

  /**
   * 🆔 ID seleccionado
   */
  selectedReceivableId: number | null;

  /**
   * 🔄 loading general
   */
  loading: boolean;

  /**
   * ❌ error global
   */
  error: string | null;
}

const initialState: PaymentHistoryCxcState = {
  history: null,

  selectedReceivableId: null,

  loading: false,
  error: null,
};

const paymentHistoryCxcSlice = createSlice({
  name: "paymentHistoryCxc",
  initialState,

  reducers: {
    /**
     * 🔄 loading
     */
    setPaymentHistoryLoading(
      state,
      action: PayloadAction<boolean>
    ) {
      state.loading = action.payload;
    },

    /**
     * ❌ error
     */
    setPaymentHistoryError(
      state,
      action: PayloadAction<string | null>
    ) {
      state.error = action.payload;
    },

    /**
     * 📌 set history
     */
    setPaymentHistory(
      state,
      action: PayloadAction<any>
    ) {
      state.history = action.payload;
      state.loading = false;
    },

    /**
     * 🆔 guardar receivable actual
     */
    setSelectedReceivableId(
      state,
      action: PayloadAction<number>
    ) {
      state.selectedReceivableId =
        action.payload;
    },

    /**
     * 🧹 limpiar state completo
     */
    clearPaymentHistory(state) {
      state.history = null;
      state.selectedReceivableId = null;
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  setPaymentHistoryLoading,
  setPaymentHistoryError,
  setPaymentHistory,
  setSelectedReceivableId,
  clearPaymentHistory,
} = paymentHistoryCxcSlice.actions;

export default paymentHistoryCxcSlice.reducer;